<template functional>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 15.308 15.308"
  >
    <g transform="translate(0.75 0.75)">
      <path
        d="M9.9,16.808A6.9,6.9,0,1,0,3,9.9,6.9,6.9,0,0,0,9.9,16.808Z"
        transform="translate(-3 -3)"
        fill="none"
        :stroke="props.colorFill"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        :style="{ fill: 'none !important' }"
      />
      <path
        d="M13,10.125H10.125V13H13Z"
        transform="translate(-4.659 -4.659)"
        :fill="props.colorFill"
        :stroke="props.colorFill"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconOnhold',

  props: {
    size: { type: [String, Number], default: '16px' },
    colorFill: { type: String, default: '#f46a6a' },
  }
}
</script>